import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 48 48'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M3.731 41 24 6l20.269 35zM8.9 38h30.2L24 12zM24 35.615q.686 0 1.151-.464.465-.465.465-1.151t-.465-1.151A1.56 1.56 0 0 0 24 32.385q-.686 0-1.151.464-.465.465-.465 1.151t.465 1.151q.465.464 1.151.464m-1.5-5.23h3v-10h-3z'
    />
  </svg>
)
export default SvgComponent
